import cx from 'classnames';
import Styles from './mIndex.module.scss';

export interface ITips {
  className?: string;
  tips: string | React.ReactNode;
  direction?: 'top' | 'bottom';
}

const Tips = ({
  className = '',
  tips,
  direction = 'bottom',
}: ITips) => {
  return (
    <div className={cx(Styles.root, className)}>
      <div className={Styles.tips}>
        { tips }
      </div>
      <div className={cx(Styles.arrow, Styles[direction])} />
    </div>
  );
};

export default Tips;
